var AlgoliaAnalyticsEvents;
(function(AlgoliaAnalyticsEvents) {
    AlgoliaAnalyticsEvents["SearchSuggestionClicked"] = 'Search Suggestion Clicked';
    AlgoliaAnalyticsEvents["SearchResultClicked"] = 'Search Result Clicked';
    AlgoliaAnalyticsEvents["ProductDetailCTAClicked"] = 'Product Detail CTA Clicked';
    AlgoliaAnalyticsEvents["FilterApplied"] = 'Filter Applied';
    AlgoliaAnalyticsEvents["ProductsViewed"] = 'Products Viewed';
})(AlgoliaAnalyticsEvents || (AlgoliaAnalyticsEvents = {}));
var AlgoliaEventType;
(function(AlgoliaEventType) {
    AlgoliaEventType["Conversion"] = 'convertedObjectIDs';
    AlgoliaEventType["ConversionAfterSearch"] = 'convertedObjectIDsAfterSearch';
    AlgoliaEventType["Click"] = 'clickedObjectIDs';
    AlgoliaEventType["ClickAfterSearch"] = 'clickedObjectIDsAfterSearch';
})(AlgoliaEventType || (AlgoliaEventType = {}));

export { AlgoliaAnalyticsEvents, AlgoliaEventType };
//# sourceMappingURL=types.js.map
